<template>
  <div>
    <h4 v-html="(active+1) +'.'+ data[active].examcont+'（'+ data[active].scores+'分）'"></h4>
    <div v-for="(item,index) in data[active].ljttabList" :key="index">
      <h5 v-html="(index + 1) +'.'+ item.examCont+'<span>['+item.examtypedesc+']（'+ item.scores+'分）</span>'">
      </h5><van-icon v-if="item.isdc" color="red" name="success" /> <van-icon v-if="!item.isdc" color="red" name="cross" />
      <div v-if="item.examtypeid=='1'" style=" pointer-events: none;">
        <!-- 单选 -->
        <van-radio-group v-model="item.examansw[0]">
          <van-radio
            v-for="(m,n) in item.examop"
            :key="m.optionid+''"
            :name="m.optionid+''"
          >
            <span  v-html="capital[n]+'.&nbsp&nbsp'+m.optioncontent" ></span>
          </van-radio>

        </van-radio-group>
        <div  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in item.examan" v-html="a.optioncontent"></a> </div>
        <div  style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="item.gradestand"></a> </div>
      </div>
      <div v-if="item.examtypeid=='2' || item.examtypeid=='7' " style=" pointer-events: none;">
        <!-- 多选 -->
        <van-checkbox-group   v-model="item.examansw">
          <van-checkbox
            v-for="(m,n) in item.examop"
            :key="m.optionid+''"
            shape="square"
            :name="m.optionid+''"
          >
            <span  v-html="capital[n]+'.&nbsp&nbsp'+m.optioncontent" ></span>
          </van-checkbox>
        </van-checkbox-group>
        <div  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in item.examan" v-html="a.optioncontent"></a> </div>
        <div  style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="item.gradestand"></a> </div>
      </div>
      <div v-if="item.examtypeid=='3'" style=" pointer-events: none;">
        <!-- 判断题 -->
        <van-radio-group v-model="item.examansw[0]">
          <van-radio
            v-for="(m,n) in item.examop"
            :key="m.optionid+''"
            :name="m.optionid+''"
          >
            <span  v-html="capital[n]+'.&nbsp&nbsp'+m.optioncontent" ></span>
          </van-radio>
        </van-radio-group>
        <div  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in item.examan" v-html="a.optioncontent"></a> </div>
        <div  style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="item.gradestand"></a> </div>
      </div>
     <div class="fill-in-blank" v-if="item.examtypeid=='4' || item.examtypeid=='9'">
        <van-cell-group>
          <div >
            考生答题：<a v-for="(item, i) in data[active].examansw"  >{{item[i]}}</a> <a v-if="data[active].examansw>1">,</a>
          </div>
        </van-cell-group>
       <div  style="height: 100px;width: 100%;padding: .625rem;"  ><van-field v-model="item.readscores" @change="piezfchange"  type="number" label="判分" /> </div>
       <div  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in item.examan" v-html="x<item.examan.length-1?a.optioncontent+',':a.optioncontent"></a> </div>
       <div  style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="item.gradestand"></a> </div>
      </div>
    <div v-if="item.examtypeid=='5'">
      <div v-if="item.examansw[0]=='考生未答'?true:false">
        <span style="color: red">{{item.examansw[0]}}</span>
      </div>
      <div v-if="item.examansw[0]=='考生未答'?false:true">
        <div v-if="item.isvoice == 'Y'">
          <van-cell-group>
            <div v-for="(anitem, i) in item.examansw" :key="i" >
              <m-audio   :src="anitem[i]" text="点击这里播放" :show-duration="true"  ref="player" :key="i"></m-audio>
            </div>
          </van-cell-group>
        </div>
        <div v-else-if="item.isvideo == 'Y'">
          <van-cell-group>
            <video controls="controls" height="150" width="300" v-if="item.examansw.length>0">
              <source :src="item.examansw[0]" type="video/mp4">
            </video>

          </van-cell-group>
        </div>
        <div v-else-if="item.isvideo != 'Y' && item.isvoice != 'Y'" >
          <van-cell-group>
            <div v-for="(animg,k) in item.examansw">
            <el-image :src="animg" :preview-src-list="item.examansw" style="width: 100px; height: 100px"></el-image>
            </div>
          </van-cell-group>
        </div>
      </div>
      <div  style="height: 100px;width: 100%;padding: .625rem;"  ><van-field v-model="item.readscores"  @change="piezfchange" type="number" label="判分" /> </div>
      <div  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in item.examan" v-html="a.optioncontent"></a> </div>
      <div  style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="item.gradestand"></a> </div>
      </div>
      <div v-if="item.examtypeid=='8'" style=" pointer-events: none;" >
        <paixu
          v-model="item.examop"
          rkey="optionid"
          showtype="optioncontent"
          @re_value="item.examansw = $event"
          :key="item.examinfoid"
        ></paixu>
        <div  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in item.examan" v-html="a.optioncontent"></a> </div>
        <div  style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="item.gradestand"></a> </div>
      </div>
      <div v-if="(index+1)==data[active].ljttabList.length">
        <div style="height: 100px;width: 100%" ></div>
      </div>
    </div>

  </div>
</template>
<script>
  import paixu from '../../common/paixu.vue';
export default {
  components: {
    paixu
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    },
    paperId:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      capital: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
    }
  },
  methods:{
    piezfchange()
    {
      this.$emit('piezfchange');
    }
    }
}
</script>
<style lang="scss">
  .fill-in-blank{
    .items{
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .item{
        display: flex;
        flex-wrap: wrap;
        input{
          border: none;
          border-bottom: 1px solid rgb(204, 203, 203);
          width: 3.75rem;
          text-align: center;
          padding: 0 .625rem;
          margin: 0 .3125rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/teacherpage/yuejuancomm/comprehension.vue